import axios from "axios";
import { getRefreshToken, getToken, updateLocalAccessToken } from "./helper";

const instance = axios.create({
    // baseURL: "https://climax.azurewebsites.net/api/",
    // baseURL: "http://54.162.189.211/",
    baseURL: "https://api.climaxdigitizing.net",
    headers: {
        "Content-Type": "application/json",
    },
});

instance.interceptors.request.use(
    (config: any) => {
        const token = getToken();
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`; // for Node.js Express back-end
        }
        return config;
    },
    (error: any) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (res: any) => {
        return res;
    },
    async (err: any) => {
        const originalConfig = err.config;

        if (originalConfig.url !== "/" && err.response) {
            // Access Token was expired
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;

                try {
                    const rs = await instance.post('/refreshtoken', {
                        refreshToken: getRefreshToken(),
                    });

                    console.log(rs, "RS")

                    const { accessToken } = rs?.data?.data;
                    updateLocalAccessToken(accessToken)

                    return instance(originalConfig);
                } catch (_error) {
                    console.log(_error)
                    localStorage.clear()
                    window.location.pathname = '/user/login'
                }
            }
        }

        return Promise.reject(err);
    }
);

export default instance;
